import "./footer.scss";

const Footer = () => {
    return <footer className={"footer"}></footer>;
};

export { Footer };
